import type { LucideIcon } from "lucide-react";
import {
  Activity,
  Building2,
  CreditCard,
  FileText,
  Image,
  KeyRound,
  LayoutDashboard,
  Mail,
  MonitorSmartphone,
  Newspaper,
  Package,
  Settings2,
  Shield,
  Tags,
  Users,
} from "lucide-react";

export interface NavItem {
  label: string;
  to: string;
  icon: LucideIcon;
  perm?: string;
}

export interface NavGroup {
  label: string;
  items: NavItem[];
}

export const NAV: NavGroup[] = [
  {
    label: "Customers",
    items: [
      { label: "Dashboard", to: "/", icon: LayoutDashboard },
      { label: "Organisations", to: "/orgs", icon: Building2, perm: "orgs:read" },
      { label: "Licenses", to: "/licenses", icon: KeyRound, perm: "licenses:read" },
      { label: "Devices", to: "/devices", icon: MonitorSmartphone, perm: "devices:read" },
      { label: "Billing", to: "/billing", icon: CreditCard, perm: "billing:read" },
    ],
  },
  {
    label: "Product",
    items: [
      { label: "FTA readiness", to: "/fta-readiness", icon: Shield, perm: "readiness:read" },
      { label: "Telemetry", to: "/telemetry", icon: Activity, perm: "telemetry:read" },
      { label: "Releases", to: "/releases", icon: Package, perm: "releases:read" },
    ],
  },
  {
    label: "Marketing",
    items: [
      { label: "Pages", to: "/cms/pages", icon: FileText, perm: "cms:read" },
      { label: "Pricing", to: "/cms/pricing", icon: Tags, perm: "cms:read" },
      { label: "Posts", to: "/cms/posts", icon: Newspaper, perm: "cms:read" },
      { label: "Media", to: "/cms/media", icon: Image, perm: "cms:read" },
      { label: "Site settings", to: "/cms/site", icon: Settings2, perm: "cms:read" },
    ],
  },
  {
    label: "System",
    items: [
      { label: "Staff", to: "/staff", icon: Users, perm: "staff:read" },
      { label: "Roles", to: "/settings/roles", icon: Shield, perm: "staff:read" },
      { label: "Audit log", to: "/settings/audit", icon: FileText, perm: "audit:read" },
      { label: "API keys", to: "/settings/api-keys", icon: KeyRound, perm: "apikeys:write" },
      { label: "Single sign-on", to: "/settings/sso", icon: Shield, perm: "staff:write" },
      { label: "Email", to: "/settings/email", icon: Mail, perm: "staff:write" },
    ],
  },
];
